import { mapActions, mapState } from 'vuex';

import { TIPOS_FORMULARIO, TAMANHO_MAXIMO_FORMULARIO_EM_BYTES } from '../../util/constantes';
import Util from '../../util/funcoes.js';

export default {
  data() {
    return {
      infiniteLoadingId: 0,
      tagPergunta: '',
      textoPergunta: '',
      validacao: {
        nome: [
          { required: true }
        ],
        tipo: [
          { required: true }
        ]
      },
      hoverGravar: false,
    }
  },

  computed: {
    ...mapState("formulariosStore", {
      formularios(state) { return state.listaFormularios },
      formularioPesquisa(state) { return state.formularioPesquisa },
      formulario(state) { return state.formularioSelecionado }
    }),
    tiposFormulario() { return TIPOS_FORMULARIO },
    exibirBotaoGravarFormulario() { return this.formulario.id === 0 },
    exibirBotaoCarregarArquivo() { return this.formulario.id === 0 },
    exibirBotaoAdicionarPergunta() { return this.formulario.id === 0 },
  },

  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("formulariosStore", [
      "listarFormularios",
      "limparFormulariosListados",
      "recuperarFormulario",
      "novoFormulario",
      "removerFormulario",
      "gravarFormulario",
      "downloadFormulario"
    ]),

    getLabel(array, element) {
      return Util.getLabel(array, element);
    },

    pesquisar($state) {
      this.showLoading();
      this.listarFormularios(this.formularioPesquisa).then((resultado) => {
        this.hideLoading();
        if(resultado.lista.length > 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    dispararPesquisa() {
      this.limparFormulariosListados();
      this.infiniteLoadingId += 1;
    },

    pesquisarHandler() {
      this.dispararPesquisa();
    },

    recuperarFormularioHandler(row) {
      const payload = { id: row.id };

      this.showLoading();
      this.recuperarFormulario(payload).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    limparArquivoUpload() {
      if(this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },

    novoFormularioHandler() {
      this.$refs["formulario"].resetFields();
      this.limparArquivoUpload();
      this.novoFormulario();
    },

    adicionarPergunta() {
      if(!this.tagPergunta.trim() || !this.textoPergunta.trim()) {
        return;
      }
      const pergunta = {
        tag: this.tagPergunta,
        texto: this.textoPergunta
      };

      this.formulario.perguntasFormulario.push(pergunta);

      this.tagPergunta = '';
      this.textoPergunta = '';
    },

    removerPergunta(pergunta) {
      this.formulario.perguntasFormulario = this.formulario.perguntasFormulario
        .filter(item => pergunta !== item);
    },

    removerFormularioHandler(formulario) {
      this.$confirm("Deseja realmente remover este Formulário?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
          this.remover(formulario);
      }).catch(() => {});
    },

    remover(formulario) {
      this.showLoading();
      this.removerFormulario(formulario).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.dispararPesquisa();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    exibirAlert(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'error' });
    },

    gravarFormularioHandler() {
      this.$refs['formulario'].validate(this.validarFormularioEGravar);
    },

    isNenhumArquivoFoiSelecionado(arquivos) {
      return arquivos.length === 0;
    },

    isArquivoExcedeTamanhoLimite(arquivo) {
      return arquivo.size > TAMANHO_MAXIMO_FORMULARIO_EM_BYTES;
    },

    validarFormularioEGravar(valid) {
      const isInvalid = !valid;
      if(isInvalid) {
        this.exibirAlert('Preencha todos os campos obrigatórios');
        return;
      }

      const arquivos = this.$refs.upload.uploadFiles;
      if(this.isNenhumArquivoFoiSelecionado(arquivos)) {
        this.exibirAlert('Selecione um arquivo');
        return;
      }

      const arquivo = this.$refs.upload.uploadFiles[0];
      if(this.isArquivoExcedeTamanhoLimite(arquivo)) {
        this.exibirAlert('O arquivo excede o tamanho máximo de 4 MB');
        return;
      }

      this.gravar();
    },

    getPayloadGravar() {
      const payload = new FormData();
      payload.append('nome', encodeURIComponent(this.formulario.nome));
      payload.append('tipo', this.formulario.tipo);
      payload.append('nomeArquivo', this.$refs.upload.uploadFiles[0].name);
      payload.append('arquivo', this.$refs.upload.uploadFiles[0].raw);

      const [tagsPerguntas, textosPerguntas] = this.montarPerguntas();

      payload.append('tagsPerguntas', encodeURIComponent(tagsPerguntas));
      payload.append('textosPerguntas', encodeURIComponent(textosPerguntas));

      return payload;
    },

    montarPerguntas() {
      const perguntas = this.formulario.perguntasFormulario;

      const tags = perguntas.map(pergunta => pergunta.tag);
      const tagsPerguntas = tags.join('|');

      const textos = perguntas.map(pergunta => pergunta.texto);
      const textosPerguntas = textos.join('|');

      return [tagsPerguntas, textosPerguntas];
    },

    gravar() {
      const payload = this.getPayloadGravar();

      this.showLoading();

      this.gravarFormulario(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO":
              this.limparArquivoUpload();
              this.$message.success(resultado.mensagem);
              this.dispararPesquisa();
              break;
            case "FALHA":
              this.exibirAlert(resultado.mensagem);
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    downloadFormularioHandler(formulario) {
      const payload = { ...formulario };
      
      this.showLoading();

      this.downloadFormulario(payload)
        .then(arquivo => {
          const url = window.URL.createObjectURL(new Blob([arquivo]));

          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.setAttribute('download', formulario.nomeArquivo);

          document.body.appendChild(anchor);
          anchor.click();

        }).catch(() => {
          this.$message.error('Não foi possível conectar-se ao servidor');
        }).finally(() => {
          this.hideLoading();
        });
    }
  }
};